import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('admin/fops', [
    '~FETCH_FOPS',
    '~PREPARE_FILTER',

    /** EDIT ACTIONS */
    'EDIT',
    'TOGGLE_EDIT_MODAL',
    'SUBMIT_EDIT',
    /** */
]);

export const ACTION = actions(TYPE);
